import React, { Component } from 'react';
import { StyleSheet, View, Text, TouchableOpacity, Image } from 'react-native';
import images from "../../images/ImagesControl";
import { Table, TableWrapper } from '../../components/Table';
import Cell from '../../components/Cell';
import Faq from './Faq';
import { Content1, Content2, Content3, Content4, Content5 } from './Content';

class Chapter3 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cateWidthArr: [150, 150],
            cateTableData1: [["Pineapple", "Strawberries"], ["Pineapple", "Strawberries"]],
            cateTableData2: [["Apple", "Banana"], ["Apple", "Banana"]],
            proList1: ["Pineapple", "Strawberries", "Kiwis", "Mangoes"],
            proList2: ["Apple", "Banana", "Peach", "Orange"],
            proDetail: {
                Pineapple: {
                    code: "Pineapple",
                    desc: "Pineapple",
                    price: "Price: HK$10",
                    image: images.pineapple,
                    response: '{"code":"Pineapple","desc":"Imported Pineapple","iRev":2,"id":1 ...}'
                },
                Strawberries: {
                    code: "Strawberries",
                    desc: "Strawberries",
                    price: "Price: HK$2",
                    image: images.strawberries,
                    response: '{"code":"Strawberries","desc":"Imported Strawberries","iRev":2,"id":2 ...}'
                },
                Kiwis: {
                    code: "Kiwis",
                    desc: "Kiwis",
                    price: "Price: HK$5",
                    image: images.kiwis,
                    response: '{"code":"Kiwis","desc":"Imported Kiwis","iRev":2,"id":3 ...}'
                },
                Mangoes: {
                    code: "Mangoes",
                    desc: "Mangoes",
                    price: "Price: HK$7",
                    image: images.mangoes,
                    response: '{"code":"Mangoes","desc":"Imported Mangoes","iRev":2,"id":4 ...}'
                },
                Apple: {
                    code: "Apple",
                    desc: "Apple",
                    price: "Price: HK$9",
                    image: images.apple,
                    response: '{"code":"Apple","desc":"Local Apple","iRev":2,"id":5 ...}'
                },
                Banana: {
                    code: "Banana",
                    desc: "Banana",
                    price: "Price: HK$11",
                    image: images.banana,
                    response: '{"code":"Banana","desc":"Local Banana","iRev":2,"id":6 ...}'
                },
                Peach: {
                    code: "Peach",
                    desc: "Peach",
                    price: "Price: HK$15",
                    image: images.peach,
                    response: '{"code":"Peach","desc":"Local Peach","iRev":2,"id":7 ...}'
                },
                Orange: {
                    code: "Orange",
                    desc: "Local Orange",
                    price: "Price: HK$20",
                    image: images.orange,
                    response: '{"code":"Orange","desc":"Local Orange","iRev":2,"id":8 ...}'
                }
            },
            proSeriesId: { "IMPORT": "1", "LOCAL": "2" },
            proSeries: 'IMPORT',
            proResponse: '',
        }
    };

    componentDidMount() {
        this._initialData();
    }

    _initialData() {
        let response = "";
        let newData = this.state.cateTableData1;

        for (let i = 0; i < newData.length; i++) {
            if (response !== "") {
                response += ",\n";
            }
            response += this.state.proDetail[newData[i][0]].response;
            if (response !== "") {
                response += ",\n";
            }
            response += this.state.proDetail[newData[i][1]].response;
        }

        this.setState({
            proResponse: response,
            proSeries: 'IMPORT',
        });
    }

    _onRefreshData(proSeries) {
        let newData = this.state.cateTableData1;

        if (proSeries === 'IMPORT') {
            newData = this.state.cateTableData1;
            newData[0][0] = this.state.proList1[Math.floor(Math.random() * this.state.proList1.length)];
            newData[0][1] = this.state.proList1[Math.floor(Math.random() * this.state.proList1.length)];
            newData[1][0] = this.state.proList1[Math.floor(Math.random() * this.state.proList1.length)];
            newData[1][1] = this.state.proList1[Math.floor(Math.random() * this.state.proList1.length)];

            this.setState({
                cateTableData1: newData,
            });
        } else {
            newData = this.state.cateTableData2;
            newData[0][0] = this.state.proList2[Math.floor(Math.random() * this.state.proList2.length)];
            newData[0][1] = this.state.proList2[Math.floor(Math.random() * this.state.proList2.length)];
            newData[1][0] = this.state.proList2[Math.floor(Math.random() * this.state.proList2.length)];
            newData[1][1] = this.state.proList2[Math.floor(Math.random() * this.state.proList2.length)];

            this.setState({
                cateTableData2: newData,
            });
        }

        let response = "";
        for (let i = 0; i < newData.length; i++) {
            if (response !== "") {
                response += ",\n";
            }
            response += this.state.proDetail[newData[i][0]].response;
            if (response !== "") {
                response += ",\n";
            }
            response += this.state.proDetail[newData[i][1]].response;
        }

        this.setState({
            proSeries: proSeries,
            proResponse: response,
        });
    }

    render() {
        const state = this.state;

        const proElement = (data) => (
            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                <Image source={state.proDetail[data].image}
                    style={{ height: 100, width: 100 }} />
                <Text>{state.proDetail[data].desc}</Text>
                <Text>{state.proDetail[data].price}</Text>
            </View>
        );

        return (
            <View style={styles.container}>

                <Content1 />

                <View style={styles.catalogContainer}>
                    <View style={styles.catalogContent}>
                        <Image source={images.logo} style={styles.catalogLogoImage} />
                        <Text style={styles.catalogLogoTitle}>
                            {"ABC Fruit Catalog"}
                        </Text>
                    </View>
                    <View style={styles.catalogContent}>
                        <View style={{ paddingRight: 20 }}>
                            <Text style={[styles.text, { fontWeight: 'bold' }]}>
                                {"Imported Product List"}
                            </Text>
                            <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                                {state.cateTableData1.map((rowData, index) => (
                                    <TableWrapper key={index} style={styles.tableWrapperStyle}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={proElement(cellData)}
                                                textStyle={styles.text}
                                                width={state.cateWidthArr[cellIndex]} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </Table>
                        </View>
                        <View>
                            <Text style={[styles.text, { fontWeight: 'bold' }]}>
                                {"Local Product List"}
                            </Text>
                            <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                                {state.cateTableData2.map((rowData, index) => (
                                    <TableWrapper key={index} style={styles.tableWrapperStyle}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={proElement(cellData)}
                                                textStyle={styles.text}
                                                width={state.cateWidthArr[cellIndex]} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </Table>
                        </View>
                    </View>
                </View>

                <Content2 />

                <Content3 />

                <Content4 />

                <Content5 />

                <View style={styles.catalogContainer}>
                    <View style={styles.catalogContent}>
                        <Image source={images.logo} style={styles.catalogLogoImage} />
                        <Text style={styles.catalogLogoTitle}>
                            {"ABC Fruit Catalog"}
                        </Text>
                    </View>
                    <View style={styles.catalogContent}>
                        <View style={{ paddingRight: 20 }}>
                            <Text style={[styles.text, { fontWeight: 'bold' }]}>
                                {"Imported Product List"}
                            </Text>
                            <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                                {state.cateTableData1.map((rowData, index) => (
                                    <TableWrapper key={index} style={styles.tableWrapperStyle}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={proElement(cellData)}
                                                textStyle={styles.text}
                                                width={state.cateWidthArr[cellIndex]} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </Table>
                            <TouchableOpacity onPress={() => this._onRefreshData("IMPORT")}>
                                <View style={styles.submitBtn}>
                                    <Text style={styles.submitBtnText}>Refresh Imported Fruits</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                        <View>
                            <Text style={[styles.text, { fontWeight: 'bold' }]}>
                                {"Local Product List"}
                            </Text>
                            <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                                {state.cateTableData2.map((rowData, index) => (
                                    <TableWrapper key={index} style={styles.tableWrapperStyle}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={proElement(cellData)}
                                                textStyle={styles.text}
                                                width={state.cateWidthArr[cellIndex]} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </Table>
                            <TouchableOpacity onPress={() => this._onRefreshData("LOCAL")}>
                                <View style={styles.submitBtn}>
                                    <Text style={styles.submitBtnText}>Refresh Local Fruits</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {'Sample request to search Products where Series = '}
                    <Text style={
                        (state.proSeries === 'IMPORT')
                            ? { color: 'green', fontWeight: 'bold' }
                            : { color: 'brown', fontWeight: 'bold' }
                    }>
                        {'“' + state.proSeries + '“'}
                    </Text>
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 20, paddingBottom: 20 }]}>
                        {
                            "GET"
                            + "\n" +
                            "http://[server]/jsf/rfws/search/search?stSearch="
                        }
                        <Text style={
                            (state.proSeries === 'IMPORT')
                                ? { color: 'green', fontWeight: 'bold' }
                                : { color: 'brown', fontWeight: 'bold' }
                        }>
                            {"pro&conds=seriesId=equals=" + state.proSeriesId[state.proSeries]}
                        </Text>
                    </Text>
                </View>

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {"Sample Response"}
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 20 }]}>
                        {
                            '{'
                            + "\n"
                            + '         "size":{'
                            + "\n"
                            + '                 "size":4,'
                            + "\n"
                            + '                 "values":['
                            + "\n"
                        }
                    </Text>
                    <Text style={
                        (state.proSeries === 'IMPORT')
                            ? { color: 'green', fontWeight: 'bold', paddingLeft: 120 }
                            : { color: 'brown', fontWeight: 'bold', paddingLeft: 120 }
                    }>
                        {state.proResponse}
                    </Text>
                    <Text style={{ paddingLeft: 20, paddingBottom: 20 }}>
                        {
                            '                 ]'
                            + "\n"
                            + '         }'
                            + "\n"
                            + '}'
                        }
                    </Text>
                </View>

                <View style={styles.faq}>
                    <Text style={{ fontSize: 20, fontWeight: 'bold' }}>
                        {"FAQ:"}
                    </Text>
                    <Faq />
                </View>

            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        width: 700,
    },
    catalogContainer: {
        flexDirection: 'column',
        borderWidth: 1,
        borderStyle: 'dashed',
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'center',
        height: 450,
    },
    catalogContent: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    catalogLogoTitle: {
        fontSize: 25,
        fontWeight: 'bold',
        paddingLeft: 20,
        fontStyle: 'iTalic'
    },
    catalogLogoImage: {
        height: 60,
        width: 180
    },
    refreshImage: {
        height: 20,
        width: 20,
        resizeMode: 'contain'
    },
    subheading: {
        paddingTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    faq: {
        paddingTop: 20,
        paddingBottom: 20,
    },
    border: {
        borderWidth: 1,
    },
    tableWrapperStyle: {
        flexDirection: 'row',
        overflow: 'hidden'
    },
    submitBtn: {
        height: 40,
        backgroundColor: '#c8e1ff',
        justifyContent: 'center',
        alignItems: 'center',
    },
    submitBtnText: {
        fontSize: 15,
        textAlign: 'center',
    },
});

export default Chapter3;



// WEBPACK FOOTER //
// ./src/pages/ch3/Chapter3.js